import PropTypes from 'prop-types';
import React from 'react';
import { Consumer as PageConsumer } from '../../../contexts/PageContext';
import CommonCardShell from '../../Layout/CommonCardShell/CommonCardShell';
import ListSection from '../../Layout/ListSection/ListSection';
import { LOGIN_LAYOUT } from '../../Login/LoginLayoutComponent/LoginLayoutComponent';
import { buildImagePath } from '../User/UserDisplay/UserImage/UserImage';
import './CreateContentWidgetV2.scss';

export default class CreatContentWidgetV2 extends React.PureComponent {
    constructor(props) {
        super();
    }

    static propTypes = {
        /**
         * object of topic page user is currently on
         */
        defaultPostLocation: PropTypes.object,
    };

    static defaultProps = {
        /**
         * topic set to null
         */
        defaultPostLocation: null,
    };
    render() {
        const imgPath = buildImagePath(
            '/v1555536356/SVGs/Create_Girl.svg',
            'medium'
        );
        return (
            <div className="component-Content-CreateContentWidgetV2-CreatContentWidgetV2">
                <PageConsumer>
                    {(context) =>
                        context.wrapAuth(
                            'CreateContent',
                            <CommonCardShell>
                                <div
                                    className="cta-wrapper"
                                    onClick={() =>
                                        context.isLoggedIn()
                                            ? context.modalTrigger(
                                                  'CreateContentPopup',
                                                  {
                                                      defaultPostLocation: this
                                                          .props
                                                          .defaultPostLocation,
                                                  }
                                              )
                                            : null
                                    }
                                >
                                    <ListSection title="Start a Post">
                                        <img src={imgPath} />
                                        <div
                                            className="text-placeholder"
                                            data-qa="Share your thoughts"
                                        >
                                            <span>
                                                Share your thoughts (even
                                                anonymously)...
                                            </span>
                                        </div>
                                    </ListSection>
                                </div>
                            </CommonCardShell>,
                            { login_trigger: 'create-content' },
                            null,
                            LOGIN_LAYOUT
                        )
                    }
                </PageConsumer>
            </div>
        );
    }
}
